import React from 'react';

import { SideNavigationItem, type SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { mdiAccount } from '@lumapps/lumx/icons';
import { useTranslate, GLOBAL } from '@lumapps/translations';

import { administratorsRoute } from '../../routes';

export interface InstanceAdminSideNavigationProps extends Partial<SideNavigationItemProps> {
    isAllowed: boolean;
}

const InstanceAdminSideNavigation: React.FC<InstanceAdminSideNavigationProps> = ({ isAllowed, ...restOfProps }) => {
    const { translateKey } = useTranslate();

    if (!isAllowed) {
        return null;
    }

    return (
        <SideNavigationItem
            {...restOfProps}
            label={translateKey(GLOBAL.SITE_ADMINS)}
            icon={mdiAccount}
            route={administratorsRoute}
        />
    );
};

InstanceAdminSideNavigation.displayName = 'SideNavigationItem';

export { InstanceAdminSideNavigation };
